import {
  IComboSlot,
  IComboSlotOption,
  IItem,
  IItemOption,
  IPicker,
  IPickerAspect,
} from '@rbi-ctg/menu';
import { TranslationKey } from 'state/intl/types';
import {
  ProductWizardStep,
  UserSelectionModifierSlotMap,
  UserSelectionPickerAspect,
} from 'state/product-wizard-v2/types';

import { IModifierData } from '../modifier/types';

import { ComboSlotType } from './ComboSlotType';

export enum ProductHierarchyType {
  DESSERTS = 'DESSERTS',
  DRINKS = 'BEVERAGES',
  FROZEN_DRINKS = 'FROZEN DRINKS',
  JUICES = 'JUICES',
  SHAKES = 'SHAKES',
  SIDES = 'SIDES/SNACKS',
  SIDES_OR_DRINKS = 'ANCILLARIES',
  SOFT_DRINKS = 'SOFT DRINKS',
}

export type DefaultModifiersMap = Record<string, number>;
export interface IProductCustomizationProps {
  currentStep: ProductWizardStep;
  filteredPickerAspects: IPickerAspect[];
  getPreviousPickerSelectionIdentifiers: (startPoint: number, endPoint: number) => string[];
  selectedPickerAspects: UserSelectionPickerAspect;
  setSelectedPickerAspects: React.Dispatch<React.SetStateAction<UserSelectionPickerAspect>>;
}

export interface IProductCustomizationItemOptionsProps {
  comboSlot?: IComboSlot | null;
  comboSlotOptions: IComboSlotOption[];
  selectedItem: IItem;
  onSelectComboSlot: (comboSlotOption: IComboSlotOption) => void;
  inlineItemCustomization?: JSX.Element | null;
  showInlineCustomization?: boolean;
}

export interface IProductCustomizationOptionsProps {
  comboSlotType?: ComboSlotType;
  comboSlot?: IComboSlot | null;
  comboSlotOptions: IComboSlotOption[];
  selectedItem: IItem;
  onSelectComboSlot: (comboSlotOption: IComboSlotOption) => void;
  modifierSelections?: UserSelectionModifierSlotMap;
  modifierDefaults?: DefaultModifiersMap;
  onModifierSelectionsChange?: SelectModifierFn;
  pickerAspectExclusions?: Set<string>;
  slotKeyToCustomize: string;
}

export interface IProductCustomizationModifiersProps {
  modifierSelections: UserSelectionModifierSlotMap;
  modifierDefaults: DefaultModifiersMap;
  onModifierSelectionsChange: SelectModifierFn;
  onResetModifierSelections: () => void;
  pickerAspectExclusions?: Set<string>;
  selectedItem: IItem;
  hasMultipleComboSlotOptions?: boolean;
}

export interface IModifierGroup {
  key?: string;
  displayGroupName?: TranslationKey;
  modifiers: IModifierData[];
}

export type SelectModifierFn = (
  selections: IModifierData['selections'],
  modifier: IItemOption
) => void;

export type IModifierGroupProps = IModifierGroup & {
  onModifierSelectionChange: SelectModifierFn;
  selectedItem: IItem;
  isFullContainer?: boolean;
};

export type ModifiersPropsMap = {
  [groupKey: string]: IModifierData[];
};

export type GroupModifiersByDisplayNameFn = (args: {
  modifiers: IItemOption[];
  modifiersMap: UserSelectionModifierSlotMap;
  pickerAspectExclusions?: Set<string>;
}) => ModifiersPropsMap;

export interface IProductSelectedItemCustomization {
  modifierSelections: UserSelectionModifierSlotMap;
  modifierDefaults: DefaultModifiersMap;
  onModifierSelectionsChange: SelectModifierFn;
  onComboSlotModifierSelectionsUpdate: () => void;
  onResetModifierSelections: () => void;
  pickerAspectExclusions?: Set<string>;
  selectedItem: IItem;
}

export interface GetModifiersWithSelectionsProps {
  modifiers: IItemOption[];
  modifiersMap: UserSelectionModifierSlotMap;
  pickerAspectExclusions?: Set<string>;
}

export interface IProductCustomizationPickerAspectProps {
  pickerData: IPicker;
  pickerSlotNumberToCustomize: string;
  userSelectedPickerAspects: UserSelectionPickerAspect | undefined;
  filteredPickerAspects: IPickerAspect[];
  getPreviousPickerSelectionIdentifiers: (startPoint: number, endPoint: number) => string[];
  selectedPickerAspects: UserSelectionPickerAspect;
  setSelectedPickerAspects: React.Dispatch<React.SetStateAction<UserSelectionPickerAspect>>;
}
